<!-- layout/main-layout.component.html -->
<div class="d-flex min-vh-100 bg-light">
  <app-sidebar></app-sidebar>

  <div class="flex-grow-1 w-100">
    <app-header></app-header>

    <main class="mx-3">
      <router-outlet></router-outlet>
      <!-- Child views load here -->
    </main>
  </div>
</div>
